'use client';

import { renderProductCards } from 'features/homepage';
import type { ProductLight } from 'models/product';
import { Carousel } from '.';

type NewArrivalsProps = {
  products: ProductLight[];
  isFetching: boolean;
  basis?: string;
  smallProducts?: boolean;
};

export default function NewArrivals({
  products,
  isFetching,
  basis,
  smallProducts,
}: NewArrivalsProps) {
  return (
    <>
      {products?.length > 0 && (
        <div className={`flex w-full flex-col gap-[1.6rem] ${basis}`}>
          <Carousel
            key="favoriteProducts"
            items={renderProductCards(
              products,
              {
                size: smallProducts ? 'sm' : 'md',
              },
              {
                data_source: 'firebase',
                section: 'new-arrivals',
              }
            )}
            basis={'basis-[48%] sm:basis-auto'}
            loading={isFetching}
          />
        </div>
      )}
    </>
  );
}
